import { render, staticRenderFns } from "./DocumentType.vue?vue&type=template&id=6af83f08"
import script from "./DocumentType.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentType.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports